// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"eea35","container":"_779f6","buttonWrapper":"db303","button":"bff08","team-chat-id":"af6bd","teamChatId":"af6bd"};